<div class="breadcamp">
    <ng-container *ngFor="let navigation of navigations;let i = index">
        <i *ngIf="i>0" class="feather feather-chevron-right"></i>
        <a [routerLink]="navigation.link?navigation.link : ''"
            [ngStyle]="{'font-weight':i==navigations.length-1?'bold':'normal'}">{{navigation.label}}</a>
    </ng-container>
</div>